import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Button = ({ type, handleClick, size, text, style, customStyle, icon, icon2, iconPosition, disabled, long }) => {
  const handleMouseDown = (e) => {
    //if (!isMobile && !isTablet) {
    e.preventDefault()
    // }
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={handleClick}
      // onMouseDown={handleMouseDown}
      className={`${styles.button} ${size ? styles[size] : ''} ${style ? styles[style] : ''} ${
        customStyle ? customStyle : ''
      } ${long ? styles.long : ''}`}>
      {iconPosition === 'start' ? icon : null}
      <span
        className={`${styles.text} ${iconPosition === 'start' && styles.textMarginLeft} ${
          (iconPosition === 'end' || icon2) && styles.textMarginRight
        }`}>
        {text}
      </span>
      {iconPosition === 'end' ? icon : null}
      {icon2}
    </button>
  )
}

Button.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  style: PropTypes.string,
  customStyle: PropTypes.string,
  icon: PropTypes.object,
  icon2: PropTypes.object,
  type: PropTypes.string,
  handleClick: PropTypes.func,
  long: PropTypes.bool
}

Button.defaultProps = {
  size: 'medium',
  style: 'primary',
  customStyle: '',
  type: 'button'
}

export default Button
